export default "__VITE_ASSET__0XGTiL$1__"